"use strict";
exports.__esModule = true;
var toPrice = function (price) {
    if (price / 1000000 > 1) {
        return comma(price / 1000000) + "m";
    }
    if (price / 1000 > 1) {
        return comma(price / 1000) + "k";
    }
    return comma(price);
};
exports.toPrice = toPrice;
var comma = function (n) {
    return (Math.round(n * 100) / 100).toLocaleString();
};
